import React from 'react';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';
import { getRegistryData } from '../../pages/registry/componentRegistry';
import { usePageDataContextOptional } from '../../contexts/PageDataContext';

interface SubmitWhamProjectionData {
  onSubmitWham?: () => void | Promise<void>;
  submitWhamDisabled?: boolean;
}

export default function SubmitWhamProjection(props: RegistryComponentProps): React.ReactElement {
  const pageData = usePageDataContextOptional();
  const data = getRegistryData<SubmitWhamProjectionData>(props);
  const onSubmit =
    data.onSubmitWham ??
    (pageData?.actions?.runWhamProjection as (() => void | Promise<void>) | undefined);
  const disabled =
    data.submitWhamDisabled ??
    (pageData?.data?.updatingPStar as boolean | undefined) ??
    false;

  const handleClick = React.useCallback(() => {
    if (typeof onSubmit === 'function') {
      void Promise.resolve(onSubmit());
    }
  }, [onSubmit]);

  return (
    <div className="noscroll-button-container" style={{ marginTop: '30px' }}>
      <button
        className="btn-primary noscroll-recalculate-all-button"
        onClick={handleClick}
        disabled={disabled}
      >
        Run WHAM Projection
      </button>
    </div>
  );
}
